
import { ErrorsOr } from "@me8eon/errors";
import { dereference, dollarsBracesVarDefn } from "@me8eon/template";
import { BaseMessage, mapMessagesErrorsOr, Message } from "@me8eon/messages";

export type DereferenceMessages<Dictionary> =
    (dictionary: Dictionary, messages: Message[]) => ErrorsOr<Message[]>

export const defaultDereferenceMessages: DereferenceMessages<any> =
    (dictionary: any, messages: Message[]): ErrorsOr<Message[]> =>
        mapMessagesErrorsOr(messages, content => ({
            value: dereference("messages", dictionary, content, { variableDefn: dollarsBracesVarDefn }),
        }));
